module.exports = __webpack_public_path__ + "static/img/headerA2.7248d89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/headerA2.png
// module id = jJDD
// module chunks = 16